import { render } from "./Stats.vue?vue&type=template&id=69e270b8"
import script from "./Stats.vue?vue&type=script&lang=js"
export * from "./Stats.vue?vue&type=script&lang=js"
script.render = render

export default script